<template>
  <div id="app" class="theme-default">
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState([])
  },
  data() {
    return {
    }
  },
  async created() {
  },
  methods: {
  }
}
</script>

<style lang="scss">
#app {
  min-width: 1366px;
}
</style>
